var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4E79E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2079 11.075L10.1839 11.454L10.0759 11.956L10.6709 12.064C11.0579 12.157 11.1349 12.296 11.0509 12.683L10.0759 17.26C9.82094 18.443 10.2159 19 11.1429 19C11.8629 19 12.6969 18.668 13.0759 18.211L13.1919 17.662C12.9289 17.894 12.5419 17.987 12.2869 17.987C11.9239 17.987 11.7929 17.732 11.8849 17.283L13.2079 11.075ZM13.2989 8.32C13.2989 8.67009 13.1599 9.00583 12.9123 9.25338C12.6648 9.50093 12.329 9.64 11.9789 9.64C11.6289 9.64 11.2931 9.50093 11.0456 9.25338C10.798 9.00583 10.6589 8.67009 10.6589 8.32C10.6589 7.96991 10.798 7.63417 11.0456 7.38662C11.2931 7.13907 11.6289 7 11.9789 7C12.329 7 12.6648 7.13907 12.9123 7.38662C13.1599 7.63417 13.2989 7.96991 13.2989 8.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.5117f9f0.svg";
export { ForwardRef as ReactComponent };